module.exports = __webpack_public_path__ + "static/media/home.d6b5f58d.svg";